import { getPerformanceObserver } from './browser-interfaces';
//监听 performance 性能指标， 当不支持 performance API 时，我们不进行任何动作
function noop() {
    // No operation performed.
}
export const observePerformance = (options, callback, once = false) => {
    let destroy = noop;
    let isExecuted = false;
    // 通过 observer 监听
    const PerformanceObserver = getPerformanceObserver();
    if (PerformanceObserver) {
        const observerInstance = new PerformanceObserver((list) => {
            // 用户配置了只回调一次，并且已经执行过，我们不再执行
            if (once && isExecuted) {
                return;
            }
            // performanceEntries 是【某小一段时间】得到的性能结果
            // 我们再遍历他们，并逐一调用 callback, 这样上层调用者无需再额外处理
            const performanceEntries = list.getEntries();
            callback(performanceEntries);
            isExecuted = true;
        });
        observerInstance.observe(options);
        // 覆写销毁函数
        destroy = () => {
            observerInstance.disconnect();
        };
    }
    return destroy;
};
